/**
 * JORealizations — Masonry gallery from /api/realizations
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { api } from "@/lib/api";

export default function JORealizations() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = await api.get("/realizations");
        const list = Array.isArray(res.data) ? res.data : (res.data?.items || []);
        if (!cancel) setItems(list.slice(0, 6));
      } catch { /* ignore */ }
    })();
    return () => { cancel = true; };
  }, []);

  if (!items.length) return null;

  return (
    <section className="jo-section" data-testid="jo-realizations">
      <div className="jo-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="jo-section-eyebrow">— Carnet de chantiers</div>
            <h2 className="jo-section-title">Des jardins<br />signés Les Jardins d'Éole</h2>
          </div>
          <Link to="/realisations" className="jo-btn-secondary self-start">
            Tous nos chantiers
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="jo-real-grid">
          {items.map((r, i) => (
            <Link
              key={r.id}
              to={`/realisations/${r.slug}`}
              className={`jo-real-tile${i % 3 === 0 ? " tall" : ""}`}
              data-testid={`jo-real-${r.slug}`}
            >
              {r.images?.[0] && <img src={r.images[0]} alt={r.title} loading="lazy" />}
              <div className="jo-real-overlay">
                <div>
                  <div className="jo-real-meta flex items-center gap-1.5">
                    {r.zone && (<><MapPin className="w-3 h-3" /> {r.zone}</>)}
                  </div>
                  <h3>{r.title}</h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
